"use strict";
/*
  These are styles that are only attached to the screen css files
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureScreenStyles = void 0;
const computedHorizontals_1 = require("./computedHorizontals");
// We need to dynamically compute where the exclude from timing icons show up since they're
// positioned from the left margin
const configureScreenStyles = (config) => {
    return {
        '.o-block-element.is-untimed.o-bracket::before': {
            left: `${(0, computedHorizontals_1.excludeFromTimingLeftPx)(config.bracket.marginLeft)}px`,
        },
        '.o-block-element.is-untimed.o-dialogue::before': {
            left: `${(0, computedHorizontals_1.excludeFromTimingLeftPx)(config.dialogue.marginLeft)}px`,
        },
        '.o-block-element.is-untimed.o-character::before': {
            left: `${(0, computedHorizontals_1.excludeFromTimingLeftPx)(config.character.marginLeft)}px`,
        },
        '.o-block-element.is-untimed.o-parenthetical::before': {
            left: `${(0, computedHorizontals_1.excludeFromTimingLeftPx)(config.parenthetical.marginLeft)}px`,
        },
        '.o-block-element.is-untimed.o-general::before': {
            left: `${(0, computedHorizontals_1.excludeFromTimingLeftPx)(config.general.marginLeft)}px`,
        },
    };
};
exports.configureScreenStyles = configureScreenStyles;
